import { ApplicationFormValues } from './types';

export const LABELS: Record<keyof ApplicationFormValues, string> = {
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email',
  phoneType: 'Phone Type',
  phoneNumber: 'Phone Number',
};

export const PHONE_TYPES = [
  { label: 'Home', value: 'home' },
  { label: 'Mobile', value: 'mobile' },
  { label: 'Work', value: 'work' },
];
